<form [formGroup]="group">
    <div class="a-w1-row">
        <p-floatlabel variant="on" class="a-W6">
            <p-select id="anio" [options]="ListaAnios" appendTo="body" formControlName="anio" styleClass="w-full"
                [filter]="true" [showClear]="true" size="small" />
            <label for="anio">Año</label>
        </p-floatlabel>
        <p-floatlabel variant="on" class="a-w6">
            <p-select id="regimen" [options]="ListaRegimen" appendTo="body" formControlName="regimen"
                styleClass="w-full" [filter]="false" [showClear]="true" size="small" />
            <label for="regimen">Regimen</label>
        </p-floatlabel>
        <p-floatlabel variant="on" class="a-w6">
            <p-select id="lineanegocio" [options]="ListaLineaNegocio" appendTo="body" formControlName="lineanegocio"
                styleClass="w-full" [filter]="false" [showClear]="true" size="small" />
            <label for="lineanegocio">Linea Negocio</label>
        </p-floatlabel>
        <p-button icon="pi pi-search" [outlined]="true" severity="info" (onClick)="search()"
            styleClass="a-w1"></p-button>
    </div>
</form>

<p-accordion value="0" [multiple]="true">
    <p-accordion-panel value="0">
        <p-accordion-header class="text-xs py-2 px-4">Resumen General CIA - ETA</p-accordion-header>
        <p-accordion-content>
            <div class="a-example-full-width-alterno-content-row ">
                <div class="a-example-full-width-alterno-content-2">
                    <app-datatable [dataTable]="paretoVendedorResumen" [metadataTable]="metadatatable3"
                        [filter]="false"></app-datatable>
                </div>
                <div class="a-example-full-width-alterno-content-2">
                    <div class="a-example-full-width-alterno-content center">
                        <canvas id="chartEjecutivosxPorcentaje01" class="canvas-grafico">
                            {{charEjecuticosPorcentaje}}
                        </canvas>
                    </div>
                </div>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="1">
        <p-accordion-header class="text-xs py-2 px-4">Detalle Clientes - ETA Frecuencia</p-accordion-header>
        <p-accordion-content>
            <div class="a-example-full-width-alterno-content-column">
                <app-datatable [dataTable]="dataReporteFrecuenciaClientesDetalle"
                    [metadataTable]="metadataReporteDetalleClientesDetalle" [filter]="false" [filter]="true"
                    [exportData]="true"></app-datatable>
                <app-datatable [dataTable]="dataReporteFrecuenciaClientesDetalle02"
                    [metadataTable]="metadataReporteDetalleClientesDetalle02" [filter]="false"></app-datatable>
            </div>
        </p-accordion-content>
    </p-accordion-panel>

    <p-accordion-panel value="2">
        <p-accordion-header class="text-xs py-2 px-4">Detalle Ejecutivo Comercial - ETA</p-accordion-header>
        <p-accordion-content>
            <app-datatable [dataTable]="paretoVendedorDetalle" [metadataTable]="metadatatable4" [filter]="false"
                [rows]="[20,50,100,200,300,500]" [exportData]="true"></app-datatable>
        </p-accordion-content>
    </p-accordion-panel>
</p-accordion>